// src/components/pos/ProductCard.js
import React from 'react';
import { Card, CardActionArea, Box, Typography } from '@mui/material';

const ProductCard = ({ product, onAddToCart }) => {
    return (
        <Card sx={{ height: '100%' }}>
            <CardActionArea onClick={() => onAddToCart(product)} sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <Box sx={{ p: 2, width: '100%' }}>
                    <Typography gutterBottom variant="subtitle1" component="div" sx={{ fontWeight: 'bold' }}>
                        {product.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Stock: {product.quantity}
                    </Typography>
                </Box>
                <Box sx={{ p: 2, pt: 0, width: '100%', textAlign: 'right' }}>
                    <Typography variant="h5" color="primary">
                        {`$${Number(product.sale_price || 0).toFixed(2)}`}
                    </Typography>
                </Box>
            </CardActionArea>
        </Card>
    );
};
export default ProductCard;